import {Pipe, PipeTransform} from "@angular/core";


@Pipe({name: 'tiposAsistencia', standalone: false})
export class TiposAsistenciaPipe implements PipeTransform {
  transform(objetos: any[], filtro: string[]) {
    return objetos.filter(obj => {
      return filtro.indexOf(obj.codigo) > -1
    });
  }
}
